import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { formatGroupDate } from '../utils/dateUtils';

interface GroupBookingCompleteProps {
  bookingNumber: string;
  bookingDates: string[];
  institutionName: string;
  bookerName: string;
}

const GroupBookingComplete: React.FC<GroupBookingCompleteProps> = ({
  bookingNumber,
  bookingDates,
  institutionName,
  bookerName,
}) => {
  const navigate = useNavigate();

  const formatDate = formatGroupDate;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-8 text-center">
      <CheckCircleIcon className="w-16 h-16 text-green-500 mx-auto mb-4" />
      <h3 className="text-2xl font-bold text-gray-800 mb-2">예약 신청이 완료되었습니다</h3>
      <p className="text-gray-500 mb-8">승인 대기 상태입니다. 담당자 확인 후 예약이 확정됩니다.</p>

      <div className="bg-gray-50 rounded-lg p-6 text-left max-w-md mx-auto mb-6">
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-sm text-gray-500">신청번호</span>
            <span className="text-sm font-bold text-green-700">{bookingNumber}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-gray-500">단체명</span>
            <span className="text-sm font-medium text-gray-800">{institutionName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-gray-500">예약자</span>
            <span className="text-sm font-medium text-gray-800">{bookerName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-gray-500">상태</span>
            <span className="text-sm font-medium text-yellow-600">승인대기</span>
          </div>
          <div className="border-t pt-3">
            <span className="text-sm text-gray-500 block mb-2">예약 날짜</span>
            <div className="flex flex-wrap gap-1.5">
              {bookingDates.sort().map(date => (
                <span key={date} className="px-2.5 py-1 bg-green-50 text-green-700 rounded text-xs font-medium border border-green-200">
                  {formatDate(date)}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-left">
        <p className="text-sm text-amber-800 font-medium mb-1">
          ※ 담당자와의 확인통화를 거쳐야만 접수가 확정됩니다.
        </p>
        <p className="text-sm text-amber-800">
          ※ 문의: 031-866-5670
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <button
          onClick={() => navigate('/application/group')}
          className="px-8 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
        >
          확인
        </button>
        <button
          onClick={() => navigate('/application/group/lookup')}
          className="px-8 py-3 bg-gray-100 text-gray-600 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
        >
          예약 조회하기
        </button>
      </div>
    </div>
  );
};

export default GroupBookingComplete;
